export default __webpack_public_path__ + "static/media/email.f40815f8.svg";